(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pb", [], factory);
	else if(typeof exports === 'object')
		exports["pb"] = factory();
	else
		root["pb"] = factory();
})(window, function() {
return 